import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PersonalFormSC, {
  PersonalFormTextInputSC,
  PersonalFormErrorSC,
} from './personal-form.styled';
import { Formik } from 'formik';
import PersonalFormSchema from './personal-form-rules';
import { BodyText } from '../../typography';
import Select, { components } from 'react-select';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import chevronImg from '../../../assets/img/svg/chevron-down.svg';
// import { regionData } from './region-data';
import { countries } from 'i18n-iso-countries/langs/sk.json';
import { euCountries } from './country-data';
import Datepicker from '../../ui/datepicker';
import moment from 'moment';
import { rodnecislo } from 'rodnecislo';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={chevronImg} alt="" />
    </components.DropdownIndicator>
  );
};

const _PersonalForm = ({ onSubmitForm, preFilledData, intl }) => {
  const [focusedInputName, setFocusedInputName] = useState('');
  const countryData = Object.entries(countries).map(([key, value]) => ({
    value: key,
    label: value,
  }));

  const filterOnlyEu = (cData) => {
    let eUCountryData = [];
    eUCountryData = [...cData.filter((item) => euCountries.indexOf(item.value.toUpperCase()) > -1)];
    return eUCountryData;
  };

  const getUserBirthDate = (userBirthNumber) => {
    let rc = rodnecislo(userBirthNumber);
    return rc.birthDate();
  };

  const [formInitialValues, setFormInitialValues] = useState({
    first_name: '',
    last_name: '',
    birth_number: '',
    birth_date: '',
    phone: '',
    email: '',
    email_confirmation: '',
    country: '',
    street: '',
    house_number: '',
    zip: '',
    city: '',
    // region: '' /* nepovinne */,
    entrepreneur: true,
  });

  useEffect(() => {
    if (Object.keys(preFilledData).length > 1) {
      setFormInitialValues({
        first_name: preFilledData.first_name ? preFilledData.first_name : '',
        last_name: preFilledData.last_name ? preFilledData.last_name : '',
        birth_number: preFilledData.personal_identification_number
          ? preFilledData.personal_identification_number
          : '',

        birth_date: preFilledData.birth_date
          ? moment(preFilledData.birth_date, 'DD.MM.YYYY').toDate()
          : preFilledData.address?.country === 'SK'
          ? getUserBirthDate(preFilledData.personal_identification_number)
          : '',
        phone: preFilledData.phone ? preFilledData.phone : '',
        email: preFilledData.email ? preFilledData.email : '',
        email_confirmation: preFilledData.email ? preFilledData.email : '',
        country:
          preFilledData.address !== null && preFilledData.address.country !== null
            ? preFilledData.address.country
            : '',
        street:
          preFilledData.address !== null && preFilledData.address.address
            ? preFilledData.address.address
            : '',
        house_number:
          preFilledData.address !== null && preFilledData.address.indicative_number
            ? preFilledData.address.indicative_number
            : '',
        zip:
          preFilledData.address !== null && preFilledData.address.postal_code
            ? preFilledData.address.postal_code
            : '',
        city:
          preFilledData.address !== null && preFilledData.address.city
            ? preFilledData.address.city
            : '',

        /*  region:
          preFilledData.address !== null && preFilledData.address.district !== null
            ? preFilledData.address.district
            : '', */
        entrepreneur: preFilledData.is_entrepreneur === 1 ? true : true,
      });
    }
  }, [preFilledData]);

  return (
    <PersonalFormSC>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={PersonalFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          onSubmitForm(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldTouched,
          setFieldValue,
        }) => {
          const firstNameHasError = errors && errors.first_name && touched.first_name;
          const lastNameHasError = errors && errors.last_name && touched.last_name;
          const birthNumberHasError = errors && errors.birth_number && touched.birth_number;
          const birthDateHasError = errors && errors.birth_date && touched.birth_date;
          const phoneHasError = errors && errors.phone && touched.phone;
          const emailHasError = errors && errors.email && touched.email;
          const emailConfirmationHasError =
            errors && errors.email_confirmation && touched.email_confirmation;
          const countryHasError = errors && errors.country && touched.country;
          const streetHasError = errors && errors.street && touched.street;
          const houseNumberHasError = errors && errors.house_number && touched.house_number;
          const zipHasError = errors && errors.zip && touched.zip;
          const cityHasError = errors && errors.city && touched.city;
          //const regionHasError = errors && errors.region && touched.region;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="onboarding_personal_form_headline_1"
                      defaultMessage={dlt['onboarding_personal_form_headline_1']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_first_name_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_first_name_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="first_name"
                        placeholder={placeholder}
                        filled={values.first_name}
                        hasError={firstNameHasError}
                        onChange={handleChange}
                        onBlur={(e) => {
                          setFocusedInputName('');
                          handleBlur(e);
                        }}
                        onFocus={() => setFocusedInputName('first_name')}
                        value={values.first_name || ''}
                      />
                    )}
                  </FormattedMessage>
                  {focusedInputName === 'first_name' && (
                    <FormattedMessage
                      id="onboarding_personal_form_fill_with_diacritics"
                      defaultMessage={dlt['onboarding_personal_form_fill_with_diacritics']}
                    />
                  )}
                  {firstNameHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage
                        id={errors.first_name}
                        defaultMessage={dlt[errors.first_name]}
                      />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_last_name_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_last_name_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="last_name"
                        placeholder={placeholder}
                        filled={values.last_name}
                        hasError={lastNameHasError}
                        onChange={handleChange}
                        onBlur={(e) => {
                          setFocusedInputName('');
                          handleBlur(e);
                        }}
                        onFocus={() => setFocusedInputName('last_name')}
                        value={values.last_name || ''}
                      />
                    )}
                  </FormattedMessage>
                  {focusedInputName === 'last_name' && (
                    <FormattedMessage
                      id="onboarding_personal_form_fill_with_diacritics"
                      defaultMessage={dlt['onboarding_personal_form_fill_with_diacritics']}
                    />
                  )}
                  {lastNameHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage
                        id={errors.last_name}
                        defaultMessage={dlt[errors.last_name]}
                      />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_birth_number_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_birth_number_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="birth_number"
                        placeholder={placeholder}
                        filled={values.birth_number}
                        hasError={birthNumberHasError}
                        onChange={(e) => {
                          handleChange(e);
                          const birthDate = getUserBirthDate(e.target.value);
                          !isNaN(birthDate) && setFieldValue('birth_date', birthDate);
                        }}
                        onBlur={handleBlur}
                        value={values.birth_number || ''}
                      />
                    )}
                  </FormattedMessage>
                  {birthNumberHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage
                        id={errors.birth_number}
                        defaultMessage={dlt[errors.birth_number]}
                      />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_birth_date_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_birth_date_placeholder']}
                  >
                    {(placeholder) => (
                      <Datepicker
                        name="birth_date"
                        placeholder={placeholder}
                        hasError={birthDateHasError}
                        value={values.birth_date}
                        onChange={(date) => {
                          setFieldTouched('birth_date', true);
                          handleChange({
                            target: {
                              name: 'birth_date',
                              value: date,
                            },
                          });
                        }}
                      />
                    )}
                  </FormattedMessage>
                  {birthDateHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage
                        id={errors.birth_date}
                        defaultMessage={dlt[errors.birth_date]}
                      />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="onboarding_personal_form_headline_2"
                      defaultMessage={dlt['onboarding_personal_form_headline_2']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>
                <div className="full-block">
                  <FormattedMessage
                    id="onboarding_personal_form_phone_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_phone_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="phone"
                        placeholder={placeholder}
                        filled={values.phone}
                        hasError={phoneHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phone || ''}
                      />
                    )}
                  </FormattedMessage>
                  {phoneHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage id={errors.phone} defaultMessage={dlt[errors.phone]} />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                <div className="full-block">
                  <FormattedMessage
                    id="onboarding_personal_form_email_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_email_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="email"
                        placeholder={placeholder}
                        filled={values.email}
                        hasError={emailHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email || ''}
                      />
                    )}
                  </FormattedMessage>
                  {emailHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage id={errors.email} defaultMessage={dlt[errors.email]} />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                <div className="full-block">
                  <FormattedMessage
                    id="onboarding_personal_form_email_confirm_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_email_confirm_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="email_confirmation"
                        placeholder={placeholder}
                        filled={values.email_confirmation}
                        hasError={emailConfirmationHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email_confirmation || ''}
                        onPaste={(e) => e.preventDefault()}
                      />
                    )}
                  </FormattedMessage>
                  {emailConfirmationHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage
                        id={errors.email_confirmation}
                        defaultMessage={dlt[errors.email_confirmation]}
                      />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="onboarding_personal_form_headline_3"
                      defaultMessage={dlt['onboarding_personal_form_headline_3']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>

                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_street_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_street_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="street"
                        placeholder={placeholder}
                        filled={values.street}
                        hasError={streetHasError}
                        onChange={handleChange}
                        onBlur={(e) => {
                          setFocusedInputName('');
                          handleBlur(e);
                        }}
                        onFocus={() => setFocusedInputName('street')}
                        value={values.street || ''}
                      />
                    )}
                  </FormattedMessage>
                  {focusedInputName === 'street' && (
                    <FormattedMessage
                      id="onboarding_personal_form_fill_with_diacritics"
                      defaultMessage={dlt['onboarding_personal_form_fill_with_diacritics']}
                    />
                  )}
                  {streetHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage id={errors.street} defaultMessage={dlt[errors.street]} />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_house_number_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_house_number_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="house_number"
                        placeholder={placeholder}
                        filled={values.house_number}
                        hasError={houseNumberHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.house_number || ''}
                      />
                    )}
                  </FormattedMessage>
                  {houseNumberHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage
                        id={errors.house_number}
                        defaultMessage={dlt[errors.house_number]}
                      />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_city_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_city_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="city"
                        placeholder={placeholder}
                        filled={values.city}
                        hasError={cityHasError}
                        onChange={handleChange}
                        onBlur={(e) => {
                          setFocusedInputName('');
                          handleBlur(e);
                        }}
                        onFocus={() => setFocusedInputName('city')}
                        value={values.city || ''}
                      />
                    )}
                  </FormattedMessage>
                  {focusedInputName === 'city' && (
                    <FormattedMessage
                      id="onboarding_personal_form_fill_with_diacritics"
                      defaultMessage={dlt['onboarding_personal_form_fill_with_diacritics']}
                    />
                  )}
                  {cityHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage id={errors.city} defaultMessage={dlt[errors.city]} />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_zip_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_zip_placeholder']}
                  >
                    {(placeholder) => (
                      <PersonalFormTextInputSC
                        type="text"
                        name="zip"
                        placeholder={placeholder}
                        filled={values.zip}
                        hasError={zipHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.zip || ''}
                      />
                    )}
                  </FormattedMessage>
                  {zipHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage id={errors.zip} defaultMessage={dlt[errors.zip]} />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_country_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_country_placeholder']}
                  >
                    {(placeholder) => (
                      <Select
                        name="country"
                        instanceId={2}
                        components={{ DropdownIndicator }}
                        value={countryData.find((op) => op.value === values.country) || null}
                        placeholder={placeholder}
                        classNamePrefix={countryHasError ? 'react-select-error' : 'react-select'}
                        onBlur={handleBlur}
                        isOptionDisabled={(op) => op.active === false}
                        options={filterOnlyEu(countryData)}
                        noOptionsMessage={() =>
                          intl.formatMessage({
                            id: 'global_no_results',
                            defaultMessage: dlt['global_no_results'],
                          })
                        }
                        onChange={(e) => {
                          setFieldTouched('birth_number', true);
                          setFieldTouched('phone', true);
                          setFieldTouched('zip', true);
                          handleChange({
                            target: {
                              name: 'country',
                              value: e.value,
                            },
                          });
                        }}
                      />
                    )}
                  </FormattedMessage>
                  {countryHasError ? (
                    <PersonalFormErrorSC>
                      <FormattedMessage id={errors.country} defaultMessage={dlt[errors.country]} />
                    </PersonalFormErrorSC>
                  ) : null}
                </div>
                {/*  <div className="half-block">
                  <FormattedMessage
                    id="onboarding_personal_form_region_placeholder"
                    defaultMessage={dlt['onboarding_personal_form_region_placeholder']}
                  >
                    {(placeholder) => (
                      <Select
                        name="region"
                        instanceId={1}
                        components={{ DropdownIndicator }}
                        value={regionData.find((op) => op.value === values.region) || null}
                        placeholder={placeholder}
                        classNamePrefix={regionHasError ? 'react-select-error' : 'react-select'}
                        onBlur={handleBlur}
                        isOptionDisabled={(op) => op.active === false}
                        options={regionData}
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: 'region',
                              value: e.value,
                            },
                          });
                        }}
                      />
                    )}
                  </FormattedMessage>
                  {regionHasError ? (
                    <PersonalFormErrorSC>{errors.region}</PersonalFormErrorSC>
                  ) : null}
                </div> */}
              </div>

              <div className="row">
                <div className="full-block with-button">
                  <BodyText>
                    <FormattedHTMLMessage
                      id="onboarding_continue_hint"
                      defaultMessage={dlt['onboarding_continue_hint']}
                    />
                  </BodyText>
                  <Button type="PRIMARY" className="form-submit" onClick={handleSubmit} withIcon>
                    <FormattedMessage
                      id="global_continue"
                      defaultMessage={dlt['global_continue']}
                    />
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </PersonalFormSC>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.user,
  };
};

const PersonalForm = connect(mapStateToProps)(_PersonalForm);

export default injectIntl(PersonalForm);
